import i18n from '@/i18n/index';
import deThreeHourOverrides from '@/i18n/de-3h-overrides';
import { isThreeHourTimeWindowEnabled } from '@/helpers/DeliveryTimeWindow';

export function applyThreeHourGermanCopy(): void {
    if (!isThreeHourTimeWindowEnabled()) {
        return;
    }

    i18n.global.mergeLocaleMessage('de', deThreeHourOverrides);
}
